// extracted by mini-css-extract-plugin
export var bulletList = "PartnerBuildSection-module__bulletList___sgX1o";
export var card = "PartnerBuildSection-module__card___h0NQU";
export var cardHeader = "PartnerBuildSection-module__cardHeader___Q8Hrv";
export var contextualStoreBackgroundDark = "#1a1b1e";
export var eyebrow = "PartnerBuildSection-module__eyebrow___F64tU";
export var feature = "PartnerBuildSection-module__feature___VJCGc";
export var featureDescription = "PartnerBuildSection-module__featureDescription___F1VyV";
export var featureGrid = "PartnerBuildSection-module__featureGrid___AeLUV";
export var featureTitle = "PartnerBuildSection-module__featureTitle___O04cT";
export var getStartedButton = "PartnerBuildSection-module__getStartedButton___dvrNm";
export var highlight = "PartnerBuildSection-module__highlight___w8A-V";
export var highlightContent = "PartnerBuildSection-module__highlightContent___bwpwq";
export var highlightDescription = "PartnerBuildSection-module__highlightDescription___5IDeZ";
export var highlightImage = "PartnerBuildSection-module__highlightImage___6YqI7";
export var highlightMedia = "PartnerBuildSection-module__highlightMedia___JulSv";
export var highlightTitle = "PartnerBuildSection-module__highlightTitle___eYXs1";
export var section = "PartnerBuildSection-module__section___9GwqZ";
export var title = "PartnerBuildSection-module__title___PJ+YF";